import { useSelector } from "react-redux";
import { AppState } from "store";

function useDeviationPermissions() {
  const isSalaryAdmin = useSelector((state: AppState) => state.auth.selectedCompany.loggedInUserIsSalaryAdmin);
  const isBusinessUnitManagerWithSalaryRights = useSelector(
    (state: AppState) => state.auth.selectedCompany.loggedInUserIsBusinessUnitManagerWithSalaryRights
  );
  const isDeviationAdmin = useSelector((state: AppState) => state.auth.selectedCompany.loggedInUserIsDeviationAdmin);

  const canManageSalary = isSalaryAdmin || isBusinessUnitManagerWithSalaryRights || isDeviationAdmin;

  return {
    isSalaryAdmin,
    isBusinessUnitManagerWithSalaryRights,
    isDeviationAdmin,
    canManageSalary,
  };
}

export default useDeviationPermissions;
